import keyBy from 'lodash-es/keyBy.js';
import { Finish, RawMaterial } from '../__generated/model/index.js';
const defaultCustomMaterialsWithoutPowderCoating = [
    {
        id: 'CustomMaterial-default-1',
        name: 'Brass 1.2mm',
        code: 'FL-PLT-BRS-12',
        finish: Finish.brushed,
        rawMaterial: RawMaterial.brass,
        thickness: 1.2,
        length: 3600,
        width: 900,
        standard: true
    },
    {
        id: 'CustomMaterial-default-2',
        name: 'Brass 1.6mm',
        code: 'FL-PLT-BRS-16',
        finish: Finish.brushed,
        rawMaterial: RawMaterial.brass,
        thickness: 1.6,
        length: 3600,
        width: 900,
        standard: true
    },
    {
        id: 'CustomMaterial-default-3',
        name: 'Brass 2.5mm',
        code: 'FL-PLT-BRS-25',
        finish: Finish.brushed,
        rawMaterial: RawMaterial.brass,
        thickness: 2.5,
        length: 1800,
        width: 900,
        standard: true
    },
    {
        id: 'CustomMaterial-default-4',
        name: 'SS304 1.2mm Brushed',
        code: 'FL-PLT-304-12',
        finish: Finish.brushed,
        rawMaterial: RawMaterial.ss304,
        thickness: 1.2,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-5',
        name: 'SS304 1.5mm Brushed',
        code: 'FL-PLT-304-15',
        finish: Finish.brushed,
        rawMaterial: RawMaterial.ss304,
        thickness: 1.5,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-6',
        name: 'SS304 2mm Brushed',
        code: 'FL-PLT-304-2',
        finish: Finish.brushed,
        rawMaterial: RawMaterial.ss304,
        thickness: 2,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-7',
        name: 'SS304 5mm Milled',
        code: 'FL-PLT-304-5',
        finish: Finish.milled,
        rawMaterial: RawMaterial.ss304,
        thickness: 5,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-8',
        name: 'SS304 6mm Milled',
        code: 'FL-PLT-304-6',
        finish: Finish.milled,
        rawMaterial: RawMaterial.ss304,
        thickness: 6,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-9',
        name: 'SS316 0.55mm Brushed',
        code: 'FL-PLT-316-55',
        finish: Finish.brushed,
        rawMaterial: RawMaterial.ss316,
        thickness: 0.55,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-10',
        name: 'SS316 0.9mm Brushed',
        code: 'FL-PLT-316-1',
        finish: Finish.brushed,
        rawMaterial: RawMaterial.ss316,
        thickness: 0.9,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-11',
        name: 'SS316 1.2mm Brushed',
        code: 'FL-PLT-316-12',
        finish: Finish.brushed,
        rawMaterial: RawMaterial.ss316,
        thickness: 1.2,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-12',
        name: 'SS316 1.6mm Brushed',
        code: 'FL-PLT-316-16',
        finish: Finish.brushed,
        rawMaterial: RawMaterial.ss316,
        thickness: 1.6,
        length: 2440,
        width: 1200,
        standard: true
    },
    {
        id: 'CustomMaterial-default-13',
        name: 'SS316 2.0mm Brushed',
        code: 'FL-PLT-316-2',
        finish: Finish.brushed,
        rawMaterial: RawMaterial.ss316,
        thickness: 2,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-14',
        name: 'SS316 3.0mm Brushed',
        code: 'FL-PLT-316-3',
        finish: Finish.brushed,
        rawMaterial: RawMaterial.ss316,
        thickness: 3,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-15',
        name: 'SS316 2.5mm Milled',
        code: 'FL-PLT-316-25M',
        finish: Finish.milled,
        rawMaterial: RawMaterial.ss316,
        thickness: 2.5,
        length: 1220,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-16',
        name: 'SS316 4mm Milled',
        code: 'FL-PLT-316-4M',
        finish: Finish.milled,
        rawMaterial: RawMaterial.ss316,
        thickness: 4,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-17',
        name: 'SS316 5.0mm Milled',
        code: 'FL-PLT-316-5M',
        finish: Finish.milled,
        rawMaterial: RawMaterial.ss316,
        thickness: 5,
        length: 1220,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-18',
        name: 'SS316 6.0mm Milled',
        code: 'FL-PLT-316-6M',
        finish: Finish.milled,
        rawMaterial: RawMaterial.ss316,
        thickness: 6,
        length: 1000,
        width: 1000,
        standard: true
    },
    {
        id: 'CustomMaterial-default-19',
        name: 'Alum milled finish 1.0mm',
        code: 'FL-PLT-ALU-1',
        finish: Finish.milled,
        rawMaterial: RawMaterial.aluminium,
        thickness: 1,
        length: 2400,
        width: 1200,
        standard: true
    },
    {
        id: 'CustomMaterial-default-20',
        name: 'Alum milled finish 1.2mm',
        code: 'FL-PLT-ALU-12',
        finish: Finish.milled,
        rawMaterial: RawMaterial.aluminium,
        thickness: 1.2,
        length: 2400,
        width: 1200,
        standard: true
    },
    {
        id: 'CustomMaterial-default-21',
        name: 'Alum milled finish 1.6mm',
        code: 'FL-PLT-ALU-16',
        finish: Finish.milled,
        rawMaterial: RawMaterial.aluminium,
        thickness: 1.6,
        length: 2400,
        width: 1200,
        standard: true
    },
    {
        id: 'CustomMaterial-default-22',
        name: 'Alum milled finish 2.0mm',
        code: 'FL-PLT-ALU-2',
        finish: Finish.milled,
        rawMaterial: RawMaterial.aluminium,
        thickness: 2,
        length: 2400,
        width: 1200,
        standard: true
    },
    {
        id: 'CustomMaterial-default-23',
        name: 'Alum milled finish 3.0mm',
        code: 'FL-PLT-ALU-3',
        finish: Finish.milled,
        rawMaterial: RawMaterial.aluminium,
        thickness: 3,
        length: 2400,
        width: 1200,
        standard: true
    },
    {
        id: 'CustomMaterial-default-24',
        name: 'Alum milled finish 4.0mm',
        code: 'FL-PLT-ALU-4',
        finish: Finish.milled,
        rawMaterial: RawMaterial.aluminium,
        thickness: 4,
        length: 2400,
        width: 1200,
        standard: true
    },
    {
        id: 'CustomMaterial-default-25',
        name: 'Flat plate 316 SS 0.7mm x 2440mm x 1220mm Brushed',
        code: 'FL-PLT-316-7',
        length: 2440,
        width: 1220,
        thickness: 0.7,
        rawMaterial: 'ss316',
        finish: 'brushed',
        standard: false
    },
    {
        id: 'CustomMaterial-default-26',
        name: 'SS304 1.2mm Milled',
        code: 'FL-PLT-304-12M',
        finish: Finish.milled,
        rawMaterial: RawMaterial.ss304,
        thickness: 1.2,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-27',
        name: 'SS304 1.5mm Milled',
        code: 'FL-PLT-304-15M',
        finish: Finish.milled,
        rawMaterial: RawMaterial.ss304,
        thickness: 1.5,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-28',
        name: 'SS304 2mm Milled',
        code: 'FL-PLT-304-2M',
        finish: Finish.milled,
        rawMaterial: RawMaterial.ss304,
        thickness: 2,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-29',
        name: 'SS316 0.55mm Milled',
        code: 'FL-PLT-316-55M',
        finish: Finish.milled,
        rawMaterial: RawMaterial.ss316,
        thickness: 0.55,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-30',
        name: 'SS316 0.9mm Milled',
        code: 'FL-PLT-316-1M',
        finish: Finish.milled,
        rawMaterial: RawMaterial.ss316,
        thickness: 0.9,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-31',
        name: 'SS316 1.2mm Milled',
        code: 'FL-PLT-316-12M',
        finish: Finish.milled,
        rawMaterial: RawMaterial.ss316,
        thickness: 1.2,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-32',
        name: 'SS316 1.6mm Milled',
        code: 'FL-PLT-316-16M',
        finish: Finish.milled,
        rawMaterial: RawMaterial.ss316,
        thickness: 1.6,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-33',
        name: 'SS316 2.0mm Milled',
        code: 'FL-PLT-316-2M',
        finish: Finish.milled,
        rawMaterial: RawMaterial.ss316,
        thickness: 2,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-34',
        name: 'SS316 3.0mm Milled',
        code: 'FL-PLT-316-3M',
        finish: Finish.milled,
        rawMaterial: RawMaterial.ss316,
        thickness: 3,
        length: 2440,
        width: 1220,
        standard: true
    },
    {
        id: 'CustomMaterial-default-35',
        name: 'SS316 0.7mm Milled',
        code: 'FL-PLT-316-7M',
        finish: Finish.milled,
        rawMaterial: RawMaterial.ss316,
        thickness: 0.7,
        length: 2440,
        width: 1220,
        standard: true
    }
];
export const defaultCustomMaterials = defaultCustomMaterialsWithoutPowderCoating.map((material)=>{
    const isStainlessSteel = material.rawMaterial === RawMaterial.ss304 || material.rawMaterial === RawMaterial.ss316;
    const isPowderCoatingMaterial = isStainlessSteel || material.rawMaterial === RawMaterial.aluminium;
    return {
        ...material,
        powderCoatingEnabled: material.thickness >= 1.2 && isPowderCoatingMaterial && (!isStainlessSteel || material.finish !== Finish.brushed)
    };
});
export const defaultCountersinks = [
    {
        id: 'Countersink-default-1',
        topRadius: 3.5,
        bottomRadius: 2.3,
        plateThicknessMin: 1.2,
        plateThicknessMax: 1.2
    },
    {
        id: 'Countersink-default-2',
        topRadius: 3.9,
        bottomRadius: 2.75,
        plateThicknessMin: 1.5,
        plateThicknessMax: 1.6
    },
    // Not available temporarily
    // {
    //   id: 'Countersink-default-3',
    //   topRadius: 2.95,
    //   bottomRadius: 2.2,
    //   plateThicknessMin: 1.5,
    //   plateThicknessMax: 1.6,
    // },
    {
        id: 'Countersink-default-4',
        topRadius: 4.5,
        bottomRadius: 3,
        plateThicknessMin: 2,
        plateThicknessMax: 2
    },
    {
        id: 'Countersink-default-5',
        topRadius: 4.5,
        bottomRadius: 3,
        plateThicknessMin: 4,
        plateThicknessMax: 4
    },
    {
        id: 'Countersink-default-6',
        topRadius: 4.5,
        bottomRadius: 3,
        plateThicknessMin: 2,
        plateThicknessMax: 2
    }
];
export const horizontalHoleCountOptions = [
    {
        label: 'Off',
        value: 0
    },
    {
        label: 'Auto',
        value: -1
    },
    {
        label: '6',
        value: 6
    },
    {
        label: '8',
        value: 8
    },
    {
        label: '10',
        value: 10
    },
    {
        label: '12',
        value: 12
    },
    {
        label: '16',
        value: 16
    }
];
export const verticalHoleCountOptions = [
    {
        label: 'Off',
        value: 0
    },
    {
        label: 'Auto',
        value: -1
    },
    {
        label: '4',
        value: 4
    },
    {
        label: '6',
        value: 6
    },
    {
        label: '8',
        value: 8
    }
];
const horizontalHoleCountLabelByValue = keyBy(horizontalHoleCountOptions, 'value');
const verticalHoleCountLabelByValue = keyBy(verticalHoleCountOptions, 'value');
export const getHorizontalHoleCountLabel = (value)=>horizontalHoleCountLabelByValue[value]?.label ?? value;
export const getVerticalHoleCountLabel = (value)=>verticalHoleCountLabelByValue[value]?.label ?? value;

//# sourceMappingURL=plate-data.js.map